import React from 'react';
import NaverNews from '../../components/Admin/NaverNews';

const NaverNewsPage = () => {
  return (
    <div className="admin-page">
      <NaverNews />
    </div>
  );
};

export default NaverNewsPage;

